module.exports = __webpack_public_path__ + "media/images/compare/compare_icon-6ed19368600fdbc7989202e002394570.svg";